import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { STATUS_MAP, formatDate, formatMoney } from '@/assets/data/data';
import { useI18n } from '@/lib/i18n';
import * as styles from './CalendarPage.module.scss';
export var CalendarPage = function (_a) {
    var clients = _a.clients, onSelectClient = _a.onSelectClient;
    var _b = useI18n(), t = _b.t, locale = _b.locale;
    var statusLabels = {
        brief: t.statusBrief,
        in_progress: t.statusInProgress,
        review: t.statusReview,
        done: t.statusDone,
    };
    var events = [];
    clients.forEach(function (c) {
        c.projects.forEach(function (p) {
            if (p.deadline && p.status !== 'done') {
                events.push({
                    id: "proj-".concat(p.id),
                    date: p.deadline,
                    type: 'deadline',
                    title: p.name,
                    subtitle: "".concat(statusLabels[p.status] || p.status, " \u00B7 ").concat(p.progress, "%"),
                    client: c,
                    color: STATUS_MAP[p.status].color,
                });
            }
        });
        c.invoices.forEach(function (inv) {
            if (inv.status === 'pending' && inv.dueDate) {
                events.push({
                    id: "inv-".concat(inv.id),
                    date: inv.dueDate,
                    type: 'invoice',
                    title: "".concat(inv.number, " \u2014 ").concat(formatMoney(inv.amount)),
                    subtitle: t.awaitingPayment,
                    client: c,
                    color: '#f59e0b',
                });
            }
            if (inv.status === 'overdue') {
                events.push({
                    id: "inv-overdue-".concat(inv.id),
                    date: inv.dueDate || inv.date,
                    type: 'overdue',
                    title: "".concat(inv.number, " \u2014 ").concat(formatMoney(inv.amount)),
                    subtitle: t.overdueExcl,
                    client: c,
                    color: '#ef4444',
                });
            }
        });
    });
    events.sort(function (a, b) { return new Date(a.date).getTime() - new Date(b.date).getTime(); });
    var today = new Date().toISOString().split('T')[0];
    var todayEvents = events.filter(function (e) { return e.date === today; });
    var upcomingEvents = events.filter(function (e) { return e.date > today; });
    var overdueEvents = events.filter(function (e) { return e.date < today; });
    var typeIcons = { deadline: '📋', invoice: '💳', overdue: '🔴' };
    var pluralEvents = function (n) {
        if (locale === 'en')
            return n === 1 ? t.event : t.events5plus;
        if (n === 1)
            return t.event;
        if (n >= 2 && n <= 4)
            return t.events2to4;
        return t.events5plus;
    };
    var sectionLabels = {
        overdue: locale === 'ru' ? 'Просрочено' : 'Overdue',
        today: locale === 'ru' ? 'Сегодня' : 'Today',
        upcoming: locale === 'ru' ? 'Предстоящие' : 'Upcoming',
        noEvents: locale === 'ru' ? 'Нет предстоящих событий' : 'No upcoming events',
        noEventsHint: locale === 'ru'
            ? 'Дедлайны проектов и даты оплаты счетов появятся здесь автоматически'
            : 'Project deadlines and invoice due dates will appear here automatically',
    };
    var renderEvent = function (event) { return (_jsxs("div", { className: styles.eventCard, onClick: function () { return onSelectClient(event.client); }, children: [_jsx("div", { className: styles.eventIcon, children: typeIcons[event.type] }), _jsxs("div", { className: styles.eventInfo, children: [_jsx("div", { className: styles.eventTitle, children: event.title }), _jsxs("div", { className: styles.eventMeta, children: [_jsx("span", { className: styles.eventDot, style: { background: event.client.color } }), event.client.name, " \u00B7 ", event.subtitle] })] }), _jsx("div", { className: styles.eventDate, children: formatDate(event.date) })] }, event.id)); };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.header, children: [_jsxs("div", { className: styles.headerTitle, children: ["\uD83D\uDCC5 ", t.calendarTitle] }), _jsxs("div", { className: styles.headerSub, children: [events.length, " ", pluralEvents(events.length)] })] }), events.length === 0 && (_jsxs("div", { className: styles.empty, children: [_jsx("div", { className: styles.emptyIcon, children: "\uD83D\uDCC5" }), _jsx("div", { className: styles.emptyTitle, children: sectionLabels.noEvents }), _jsx("div", { className: styles.emptyText, children: sectionLabels.noEventsHint })] })), overdueEvents.length > 0 && (_jsxs("div", { className: styles.section, children: [_jsxs("div", { className: styles.sectionTitle, children: [_jsx("span", { className: styles.sectionDot, style: { background: '#ef4444' } }), sectionLabels.overdue, " (", overdueEvents.length, ")"] }), _jsx("div", { className: styles.eventList, children: overdueEvents.map(renderEvent) })] })), todayEvents.length > 0 && (_jsxs("div", { className: styles.section, children: [_jsxs("div", { className: styles.sectionTitle, children: [_jsx("span", { className: styles.sectionDot, style: { background: '#6366f1' } }), sectionLabels.today, " (", todayEvents.length, ")"] }), _jsx("div", { className: styles.eventList, children: todayEvents.map(renderEvent) })] })), upcomingEvents.length > 0 && (_jsxs("div", { className: styles.section, children: [_jsxs("div", { className: styles.sectionTitle, children: [_jsx("span", { className: styles.sectionDot, style: { background: '#22c55e' } }), sectionLabels.upcoming, " (", upcomingEvents.length, ")"] }), _jsx("div", { className: styles.eventList, children: upcomingEvents.map(renderEvent) })] }))] }));
};
